import React from "react";
import FieldWrapper from "./FieldWrapper";
import Icon from "../../Common/Icon";

export default class Field extends FieldWrapper {
  constructor() {
    super();
  }
  renderField() {
    const { config } = this.props;
    const { icon, label, labelInInput, labelHidden, name } = config;

    return (
      <React.Fragment>
        <div className="field__input-container">
          {!icon ? null : (
            <Icon className="field__icon" iconName={icon} title={label} />
          )}
          {!icon && !labelInInput ? null : (
            <label
              className={`field__input-label ${labelHidden ? "sr-only" : ""}`}
              htmlFor={name}
            >
              {label}
            </label>
          )}
          {this.renderInput()}
        </div>
      </React.Fragment>
    );
  }

  renderInput() {
    return null;
  }

  onFocus = () => {
    this.setState({
      focused: true,
    });
  };
  onBlur = (e) => {
    this.setState({
      focused: false,
    });
    if (e) this.props.formikField.onBlur(e);
  };
}



// WEBPACK FOOTER //
// ./src/components/FormTemplates/Common/Field.js